export const RenderChilds = ({
  child1,
  child2,
  condition,
}: {
  child1: JSX.Element;
  child2: JSX.Element;
  condition: boolean;
}) => (condition ? child1 : child2);
